import { formatDateForHash, getHashObj, getSasonBasedOnDate, parseHashParams } from "@/utils/utils";
import getFirstAvailableResponse from "@/vue/planning/logic/getFirstAvailableResponse"
import isHaveAvailability from "@/vue/planning/logic/isHaveAvailability"
import { AvailabilitiesResponse } from "@/types/responses";
import packConfig from "@/config/packConfig"
import store from "@/vue/planning/store/store"
import { getAvailablePackagesWiyp } from "./availablesPackagesWiyp";
import { isSameTrainPackageType } from "@/config/trainPackageConfig"
import _ from "lodash";

const getHashPackCode = (): string | undefined => {
    const hash = window.location.hash.replace("#", "")
    const hashObj = getHashObj(hash) as {[key: string]: string}
    const hashPackCode: string | undefined = hashObj.packCode
    return hashPackCode
}

const ensureValidPackCodeIsSelected = (avail_resp: AvailabilitiesResponse, dispatch: any) => {
    // const availablePackageCodeWiyp: { codePackage: string, prestId: string, maxPromo: number }[] = []

    // avail_resp.availablePackages!.forEach(availablePackage => {
    //     availablePackageCodeWiyp.push({ codePackage: availablePackage.codePackage!, prestId: availablePackage.prestId! as string, maxPromo: 0 })
    // });
    // avail_resp.prestations!.forEach(prestation => {
    //     availablePackageCodeWiyp.push({ codePackage: prestation.codePackage!, prestId: prestation.prestId!, maxPromo: 0 })
    // });
    
    // // Ensure only unique codePackage/prestId combinations
    // const uniqueMap = new Map();
    // for (const entry of availablePackageCodeWiyp) {
    //     const key = `${entry.codePackage}-${entry.prestId}`;
    //     if (!uniqueMap.has(key)) {
    //         uniqueMap.set(key, entry);
    //     }
    // }
    // store.state.availablePackageCodeWiyp = Array.from(uniqueMap.values());

    // store.state.availablePackageCodeWiyp = getAvailablePackagesWiyp(avail_resp);

    const hashPackCode: string | undefined = getHashPackCode()

    const hashPackIsAvailable = !!hashPackCode && store.state.availablePackageCodeWiyp.some(p =>
        p.codePackage === hashPackCode || isSameTrainPackageType(p.codePackage, hashPackCode)
    )

    if(!hashPackIsAvailable) {
        let wasPackageSet = false
        for(const priorityPackCode of packConfig) {
            if(store.state.availablePackageCodeWiyp.find(p => p.codePackage === priorityPackCode)) {
                dispatch("setPackage", priorityPackCode)
                wasPackageSet = true
                break
            }
        }
        if(!wasPackageSet) {
            dispatch("setPackage", avail_resp?.codePack) 
        }
    }
}

const makeInitialAvailRequest = async (store: any) => {
    const { state, commit, dispatch } = store

    const hashPackCode: string | undefined = getHashPackCode()
    let avail_resp = await getFirstAvailableResponse(store, hashPackCode)

    // Check if we need to switch season based on dates
    if (avail_resp?.endDates?.startDate) {
        const seasonBasedOnDate = getSasonBasedOnDate(avail_resp.endDates.startDate)

        if (seasonBasedOnDate !== state.season) {
            commit("setSeason", seasonBasedOnDate)
            window.seasonManager.switchSeasonWithoutReloading()
            avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        }
    }

    // If still no availability - try switching seasons
    if (!isHaveAvailability(avail_resp)) {
        const newSeason = state.season === "E" ? "H" : "E"
        commit("setSeason", newSeason)
        window.seasonManager.switchSeasonWithoutReloading()

        // Try again with new season
        avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        
        // If still no availability, try one more time with the original season
        if (!isHaveAvailability(avail_resp)) {
            commit("setSeason", state.season === "E" ? "H" : "E")
            window.seasonManager.switchSeasonWithoutReloading()
            avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        }
    }

    if (!isHaveAvailability(avail_resp)) {
        commit("setProductUnavailable", true)
        dispatch("setLoading", false)
        return
    }

    // set packCode if it was empty, or it's not available
    ensureValidPackCodeIsSelected(avail_resp, dispatch)

    // set dates from response if url doesnt have them
    if (Object.keys(state.dates).length === 0) {
        const newDates = {
            "BeginDate": formatDateForHash(avail_resp?.endDates?.startDate),
            "EndDate": formatDateForHash(avail_resp?.endDates?.endDate),
        };
        dispatch("setDates", newDates)
    }

    // Keep the hash/state pack when it is already valid. Merged related-package
    // responses can have a different codePack (or a corrupted array if strings were spread).
    const responsePackCode = Array.isArray(avail_resp.codePack)
        ? avail_resp.codePack.find((code: string) => typeof code === "string" && code.length > 1)
        : avail_resp.codePack
    if (!state.packCode && responsePackCode) {
        dispatch("setPackage", responsePackCode)
    }

    return avail_resp
}

export default makeInitialAvailRequest